// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatsAppChatWidget_root__2mJlK"};